import { Component, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src

@Component
export default class SidenaviSearchkeyword extends Vue {
  private　name = 'sidenavisearchkeyword';
}
